"use client";

import { useAutoTranslate } from "@/lib/i18n/useAutoTranslate";
import React from "react";
import { AuthHeaderProps } from "./types";

const AuthHeader: React.FC<AuthHeaderProps> = ({
  heading = "",
  description1 = "",
  description2 = "",
}) => {
  const tr = useAutoTranslate();

  return (
    <div className="text-center mb-8">
      {heading && (
        <p className="text-primary text-2xl md:text-3xl font-bold mb-2">
          {tr(heading)}
        </p>
      )}
      {description1 && (
        <p className="text-text-light font-normal text-xs md:text-base">
          {tr(description1)}
        </p>
      )}
      {description2 && (
        <p className="text-text-light font-normal text-xs md:text-base">
          {tr(description2)}
        </p>
      )}
    </div>
  );
};

export default AuthHeader;
